var header = document.querySelector('.header');
var search_input = document.querySelector('.header');
var magazine_trigger = document.querySelector('.header__magazine__trigger');
var letters_trigger = document.querySelector('.header__letters__trigger');
var search_trigger = document.querySelector('.header__search__trigger');
var mobile_trigger = document.querySelector('.header__mobile-trigger');
var mobile_back = document.querySelectorAll('.header__overlay__mobile-back');

// Nav Magazine Trigger
magazine_trigger.addEventListener('click', (e)=>{
  e.preventDefault();
  header.classList.remove('letters-active');

  if (header.classList.contains('magazine-active')) {
    header.classList.remove('magazine-active');
  } else {
    header.classList.add('magazine-active');
  }
})


// Nav Letters Trigger
letters_trigger.addEventListener('click', (e)=>{
  e.preventDefault();
  header.classList.remove('magazine-active');

  if (header.classList.contains('letters-active')) {
    header.classList.remove('letters-active');
  } else {
    header.classList.add('letters-active');
  }
})


// Close overlay by clickling outside header
document.addEventListener('click', function(event) {
  var isClickInside = header.contains(event.target);

  if (!isClickInside) {
    header.classList.remove('letters-active');
    header.classList.remove('magazine-active');
  }
});


// Search Trigger
search_trigger.addEventListener('click', function(e) {
  e.preventDefault();
  header.classList.remove('letters-active');
  header.classList.remove('magazine-active');
  if (header.classList.contains('search-active')) {
    header.classList.remove('search-active');
  } else {
    header.classList.add('search-active');
  }
});


// Mobile Trigger
mobile_trigger.addEventListener('click', (e)=>{
  e.preventDefault();
  if (header.classList.contains('mobile-active')) {
    header.classList.remove('mobile-active');
    header.classList.remove('letters-active');
    header.classList.remove('magazine-active');
  } else {
    header.classList.add('mobile-active');
  }
})



mobile_back.forEach(function(button){
  button.addEventListener('click', (e)=>{
    e.preventDefault();
    if (header.classList.contains('letters-active')) {
      header.classList.remove('letters-active');
    } 
    if (header.classList.contains('magazine-active')) {
      header.classList.remove('magazine-active');
    }
  })
})



